import { render, staticRenderFns } from "./gTabs.vue?vue&type=template&id=caec7b38&scoped=true"
import script from "./gTabs.vue?vue&type=script&lang=js"
export * from "./gTabs.vue?vue&type=script&lang=js"
import style0 from "./gTabs.vue?vue&type=style&index=0&id=caec7b38&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caec7b38",
  null
  
)

export default component.exports